import en from './profile.en';

const enConfig = { en };

export default enConfig;
